import { gsap } from 'gsap';

// Градиент EC6328 → E4B064 → 65C5E6
const color12 = gsap.utils.interpolate("#EC6328", "#E4B064");
const color23 = gsap.utils.interpolate("#E4B064", "#65C5E6");

const getGradientColor = (progress) => {
  // первая половина: 0 → 0.5
  if (progress <= 0.5) {
    return color12(progress / 0.5);
  }
  // вторая половина: 0.5 → 1
  return color23((progress - 0.5) / 0.5);
};

const TYPE_SPEED = 0.09;
const DELETE_SPEED = 0.06;
const PAUSE_AFTER_TYPE = 1.6;
const PAUSE_AFTER_DELETE = 0.6;
const OBSERVER_THRESHOLD = 0.1;

function initTypewriter(typeEl) {
  const getTypewriterSource = () => {
    if (typeEl.__typewriterSourceText) {
      return typeEl.__typewriterSourceText;
    }

    const clone = typeEl.cloneNode(true);
    clone.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));

    return clone.textContent || '';
  };

  const sourceText = getTypewriterSource()
      .replace(/\u00a0/g, ' ')
      .replace(/\r\n/g, '\n')
      .replace(/\n[ \t]+/g, '\n')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/[ \t]+/g, ' ')
      .trim();

  // Проверяем наличие разделителя ;
  const phrases = sourceText.includes(';')
      ? sourceText.split(';').map(p => p.trim()).filter(p => p.length > 0)
      : [sourceText];

  const typeDelay = parseFloat(typeEl.dataset.typewriterDelay) || 0;
  const caretDelay = parseFloat(typeEl.dataset.caretDelay) || 0;

  let index = 0;
  let isTyping = true;
  let currentPhraseIndex = 0;

  const renderText = (value) => {
    const escaped = value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    typeEl.innerHTML = escaped.replace(/\n/g, '<br>');
  };

  renderText('');
  typeEl.classList.remove('is-caret-visible');

  // caret delay
  gsap.delayedCall(caretDelay, () => {
    typeEl.classList.add('is-caret-visible');
  });

  const tl = gsap.timeline({
    repeat: typeEl.dataset.typewriter === 'once' ? 0 : -1,
    paused: true,
    delay: typeDelay,
  });

  const buildTimelineForPhrase = (phraseText) => {
    // Печать текста
    tl.to({}, {
      duration: phraseText.length * TYPE_SPEED,
      onUpdate() {
        if (!isTyping) return;
        const next = Math.floor(this.progress() * phraseText.length);
        if (next !== index) {
          index = next;
          renderText(phraseText.slice(0, index));
        }
      },
    });

    // Пауза после печати
    tl.to({}, { duration: PAUSE_AFTER_TYPE });

    // Стирание (если не режим 'once')
    if (typeEl.dataset.typewriter !== 'once') {
      tl.to({}, {
        duration: phraseText.length * DELETE_SPEED,
        onStart() {
          isTyping = false;
        },
        onUpdate() {
          const next = phraseText.length - Math.floor(this.progress() * phraseText.length);
          if (next !== index) {
            index = next;
            renderText(phraseText.slice(0, index));
          }
        },
        onComplete() {
          isTyping = true;
          index = 0;
        },
      });

      // Пауза после стирания
      tl.to({}, { duration: PAUSE_AFTER_DELETE });
    }
  };

  // Если одна фраза - работаем как раньше
  if (phrases.length === 1) {
    buildTimelineForPhrase(phrases[0]);
  } else {
    // Если несколько фраз - строим таймлайн с ротацией
    phrases.forEach((phrase, i) => {
      tl.add(() => {
        currentPhraseIndex = i;
        index = 0;
      });
      buildTimelineForPhrase(phrase);
    });
  }

  return tl;
}

if (document.querySelector('[data-splitting-title]')) {
  document.querySelectorAll('[data-splitting-title]').forEach((item) => {
    const typeEl = item.querySelector('.typewriter-text');
    if (typeEl && !typeEl.__typewriterSourceText) {
      const clone = typeEl.cloneNode(true);
      clone.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
      typeEl.__typewriterSourceText = clone.textContent || '';
    }

    Splitting({
      target: item,
      by: 'words',
      ignore: '[data-no-splitting]',
    });

    if (!typeEl) return;

    const mode = typeEl.dataset.typewriter || 'loop';
    const tl = initTypewriter(typeEl);

    if (mode === 'loop') {
      tl.play();
      return;
    }

    const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          tl.play();

          if (mode === 'once') {
            observer.disconnect();
          }
        },
        { threshold: OBSERVER_THRESHOLD }
    );

    observer.observe(typeEl);
  });
}

if (document.querySelector('[data-splitting-words]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-words]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });
  });
}

if (document.querySelector('[data-splitting-chars]')) {
  const targets = document.querySelectorAll('[data-splitting-chars]');

  targets.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });

    if (item.classList.contains('cl-gradient-js')) {
      const chars = item.querySelectorAll('.char');
      const total = chars.length - 1;

      gsap.set(chars, {
        color: (index) => getGradientColor(index / total),
      });

      item.classList.add('is-init-cl-gradient-js');

      return;
    }

    const innerGradientBlocks = item.querySelectorAll('.cl-gradient-js');

    if (innerGradientBlocks.length > 0) {
      innerGradientBlocks.forEach((block) => {
        const blockChars = block.querySelectorAll('.char');
        const total = blockChars.length - 1;

        gsap.set(blockChars, {
          color: (index) => getGradientColor(index / total),
        });

        block.classList.add('is-init-cl-gradient-js');
      });
    }
  });
}

/*if (document.querySelector('[data-splitting-chars]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-chars]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });
  });
  gsap.set(splitText.chars, {
    color: (index, target, targets) => color(index / (targets.length - 1))
  });
}*/

/*const variableFontAnimationElsArr = document.querySelectorAll('[data-variable-font-animation]');
variableFontAnimationElsArr.forEach((variableFontAnimationEl) => {
  const timeline = gsap.timeline({repeat: -1});
  const chars = variableFontAnimationEl.querySelectorAll(".char");

  // gsap.set(".one", {color: "#3498DB"});
  // gsap.set(".two", {color: "#E74C3C"});
  // gsap.set(".three", {color: "#F1C40F"});
  // gsap.set(".four", {color: "#3498DB"});
  // gsap.set(".five", {color: "#27AE60"});
  // gsap.set(".six", {color: "#E74C3C"});

  timeline.from(chars, {opacity: 0, scale: 0, ease: "sine", delay: 0.25})
      .to(".char", {
        opacity: 1,
        "--font-weight": 700,
        duration: 1.2,
        ease: "sine.inOut",
        stagger: {
          yoyo: true,
          each: 0.1,
          repeat: -1
        }
      }, 1);
})*/
